import "./styles/css/main.css";
import App from "./scripts/App";
import registerServiceWorker from "./registerServiceWorker";
import React from "react";
import { render } from "react-dom";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./scripts/store/store";
import { AUTHENTICATED, UNAUTHENTICATED } from "./scripts/actions/actions";
import "@babel/polyfill";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
// eslint-disable-next-line
import ROLLBAR from "./scripts/Rollbar/Rollbar";
import { theme } from "./scripts/CreateStudyPage/MaterialStyling";

console.log(`${process.env.REACT_APP_NAME} ${process.env.REACT_APP_VERSION}`);

const user = localStorage.getItem("user");

if (user) {
  store.dispatch({ type: AUTHENTICATED });
} else {
  store.dispatch({ type: UNAUTHENTICATED });
}

window.store = store;

const root = createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </StyledEngineProvider>
  </Provider>
);
registerServiceWorker();
